import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { analyzeAndValidateNgModules } from '@angular/compiler';

@Injectable()

export class TokenInterceptor implements HttpInterceptor {

  authService: AuthService;

  constructor(private injector: Injector, private router: Router) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.authService = this.injector.get(AuthService);
    const access_token = this.authService.access_token;
    const contentTypeNotConfigured = !request.headers.has('Content-Type');
    if (contentTypeNotConfigured) {
      const requestClone = request.clone({
        setHeaders: {
          'Authorization': `Bearer ${access_token}`,
          'Content-Type': 'application/json'
        },
      });
      return next.handle(requestClone);
    }
    request.headers.append('Authorization', `Bearer ${access_token}`);
    return next.handle(request);
  }
}



// WEBPACK FOOTER //
// ./src/app/service/core/interceptor.service.ts